import { useSelector } from 'react-redux';
import { selectSettings } from '../../store/selectors/settingsSelectors';

export function useBrokerCode() {
  const settings = useSelector(selectSettings);

  return settings?.BrokerCode ?? 'HAA';
}
